import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { obterConsultaEscolaridade } from '../../api/presencaAPI';

export interface IntegrantePovoamentoEscolaridade {
  tipoRelacaoParentescoRF: { codigo: number, nome: string };
  nomePessoa: string;
  temEscolaridade: boolean;
  estadoCadastralMembroDTO?: { codigo: number, nome: string };
  nis?: number;
  cpf?: number;
  mesAtualizacao?: Date;
  codigoInepEscola?: number;
  nomeInepEscola?: string;
  cursoFrequentado?: string;
  anoSerieFrequentada?: string;
  competencia?: string;
}

export interface ConsultaEscolaridadeState {
  integrantesPovoamento: IntegrantePovoamentoEscolaridade[];
}

const initialState: ConsultaEscolaridadeState = {
  integrantesPovoamento: []
};

export const obterIntegrantesPovoamento = createAsyncThunk<
  IntegrantePovoamentoEscolaridade[],
  number
>('consultaEscolaridade/obterIntegrantesPovoamento', async (numeroFamiliar) => {
  return obterConsultaEscolaridade(numeroFamiliar);
});

export const consultaEscolaridadeSlice = createSlice({
  name: 'consultaEscolaridade',
  initialState,
  reducers: {
    limpar: (state) => {
      state.integrantesPovoamento = initialState.integrantesPovoamento;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(obterIntegrantesPovoamento.fulfilled, (state, action) => {
      state.integrantesPovoamento = action.payload;
    });
  },
});

export const { limpar } = consultaEscolaridadeSlice.actions;

export const selectIntegrantesPovoamento = (state: RootState) =>
  state.consultaEscolaridade.integrantesPovoamento;

export default consultaEscolaridadeSlice.reducer;
